/**
 * Cognito NEW_PASSWORD_REQUIRED context for the regulator set-password screen.
 *
 * React Router `location.state` is the source of truth after sign-in, but a
 * full reload (or a language switch that used to reload) drops it. Session
 * storage keeps the challenge for this tab only — never the typed password.
 */

export const REGULATOR_SET_PASSWORD_CHALLENGE_KEY =
  "regulator_portal_set_password_challenge";

export type RegulatorSetPasswordChallenge = {
  username: string;
  sessionToken: string;
};

const isChallenge = (
  value: unknown,
): value is RegulatorSetPasswordChallenge => {
  if (!value || typeof value !== "object") return false;
  const record = value as Record<string, unknown>;
  return (
    typeof record.username === "string" &&
    record.username.length > 0 &&
    typeof record.sessionToken === "string" &&
    record.sessionToken.length > 0
  );
};

export const readSetPasswordChallenge =
  (): RegulatorSetPasswordChallenge | null => {
    try {
      const raw = sessionStorage.getItem(REGULATOR_SET_PASSWORD_CHALLENGE_KEY);
      if (!raw) return null;
      const parsed: unknown = JSON.parse(raw);
      return isChallenge(parsed) ? parsed : null;
    } catch {
      return null;
    }
  };

export const writeSetPasswordChallenge = (
  challenge: RegulatorSetPasswordChallenge,
): void => {
  try {
    sessionStorage.setItem(
      REGULATOR_SET_PASSWORD_CHALLENGE_KEY,
      JSON.stringify(challenge),
    );
  } catch {
    // Private mode / quota — the in-memory route state still works.
  }
};

export const clearSetPasswordChallenge = (): void => {
  try {
    sessionStorage.removeItem(REGULATOR_SET_PASSWORD_CHALLENGE_KEY);
  } catch {
    // ignore
  }
};
